<template>
  <div
    @contextmenu="selectComponentDEV($event, schema.model)"
    :class="['d-flex', getSelectedDEV && 'dev-selected-component']"
    :key="generateId(schema.model)"
  >
    <i4pro-icon-popover
      v-if="schema.attributesInfo"
      :class="[schema.attributesInfo.right ? 'ml-1 order-2' : 'mr-1']"
      :schema="schema"
      :model="model"
    ></i4pro-icon-popover>
    <v-dialog
      ref="dialog"
      v-model="modal"
      :return-value.sync="value"
      :disabled="schema.attributesTextField.readonly"
      v-bind="schema.attributesDialog"
    >
      <template v-slot:activator="{ on }">
        <v-text-field
          :name="schema.model"
          :id="generateId(schema.model)"
          slot="activator"
          v-model="value"
          v-bind="schema.attributesTextField"
          :disabled="schema.readonly"
          :rules="rules"
          @click:clear="clear()"
          @change="onChange"
          @focus="onFocus"
          @input="onInput"
          v-on="on"
        >
          <template v-slot:label>
            {{ schema.attributesTextField.label }}
            <span v-if="schema.rules.includes('required')" class="red--text">*</span>
          </template>
        </v-text-field>
      </template>

      <v-time-picker v-model="value" v-bind="schema.attributesTimePicker">
        <v-btn :text="schema.btnFlat" :color="schema.btnCancelColor" @click="modal = false">{{
          schema.btnCancelLabel
        }}</v-btn>

        <v-btn :text="schema.btnFlat" :color="schema.btnSaveColor" @click="$refs.dialog.save(value)">{{
          schema.btnSaveLabel
        }}</v-btn>
      </v-time-picker>
    </v-dialog>
  </div>
</template>

<script>
import { abstractField } from 'vue-form-generator';
import devComponentMixin from '@/mixins/dev-component-mixin';
import rulesMixin from '@/mixins/rules-mixin';
import inputEventsMixin from '@/mixins/input-events-mixin';
import componentMixin from '@/mixins/component-mixin';
export default {
  mixins: [abstractField, devComponentMixin, rulesMixin, inputEventsMixin, componentMixin],

  components: {
    i4proIconPopover: () => import('@/components/icons/i4pro-icon-popover')
  },

  data: () => ({
    modal: false
  }),

  methods: {
    onChange: async function () {
      this.changeEvents();
    },

    clear() {
      this.$nextTick(() => (this.model[this.schema.model] = ''));
    }
  },

  watch: {
    modal(newValue) {
      if (this.schema.attributesTextField.readonly) this.modal = false;
    },

    value(newValue) {
      if (this.schema.hasConditions) this.$store.dispatch('page/conditions', this.formOptions);
    }
  }
};
</script>

<style lang="scss" scoped>
.v-dialog__container {
  width: 100%;
}
</style>
